import {useContext} from "react";
import {observer} from "mobx-react-lite";

import Loader from "./loader";
import useTranslations from "../hooks/use-translations";
import Welcome from "./welcome.tsx";
import BackgroundMedia from "./background-media.tsx";
import {AppStoreContext} from "../store/app-store.ts";

const Home = observer(() => {
    const { context, isTranslationsLoading } = useContext(AppStoreContext);
    useTranslations(context?.customerDefaultLanguage);

    if (isTranslationsLoading) {
        return <Loader />;
    }

    return context.backgroundMedia?.path
        ? <BackgroundMedia path={context.backgroundMedia.path} />
        : <Welcome context={context} />;
});

export default Home;
